import { auth } from '@/api'
import { getProvider } from '@/helpers/sso'
import i18n from '@/lang'
import router from '@/router'
import Cookies from 'js-cookie'

const domain = process.env.DOMAIN

const login = (context, creds) => {
  context.commit('SET_LOADING', true)
  return new Promise(async (resolve, reject) => {
    try {
      let response = await auth.connect(creds)
      storeToken(context, response.data.token)
      resolve()
    } catch (error) {
      handleError(context, { message: i18n.t('loginForm.errors.wrongCredentials') })
      reject(error)
    }
  })
}

const loginWithSSO = (context, creds) => {
  context.commit('SET_LOADING', true)
  return new Promise(async (resolve, reject) => {
    try {
      creds.username = creds.username.toLowerCase().trim()
      const provider = getProvider(creds.username)
      if (!provider) { throw Error('No provider found') }

      Cookies.set('sso_redirect', router.currentRoute.query.redirect, { expires: 0.5, domain })
      await auth.connectWithSSO(provider)
      resolve()
    } catch (error) {
      handleError(context, { message: i18n.t('loginForm.errors.unrecognizedProvider') })
      reject(error)
    }
  })
}

const checkToken = (context, token) => {
  context.commit('SET_LOADING', true)
  return new Promise(async (resolve, reject) => {
    try {
      await auth.checkStatus(token)
      resolve()
    } catch (error) {
      handleError(context, { message: i18n.t('loginForm.errors.wrongCredentials') })
      reject(error)
    }
  })
}

const storeToken = (context, token) => {
  Cookies.set('token', token, { expires: 0.5, domain })
  auth.updateToken(token)
  context.commit('SET_LOGIN_SUCCESS', token)
}

const handleError = (context, { message }) => {
  Cookies.remove('token', { domain })
  context.commit('SET_LOGIN_ERROR', message)
  context.commit('SET_LOADING', false)
  setTimeout(() => { context.commit('RESET_ERROR') }, 4000)
}

export default {
  login,
  loginWithSSO,
  checkToken,
  storeToken
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js